import { Component } from '@angular/core';

@Component({
    selector: 'app-data-processing-agreement',
    templateUrl: './data-processing-agreement.component.html',
    styleUrl: './data-processing-agreement.component.scss',
    standalone: false
})
export class DataProcessingAgreementComponent {

}
